import { Dialog, DialogContent } from "@mui/material"
import { BoxFC } from "components/BoxCustom"
import PaperComponent from "components/PaperComponent"
import { DialogFooter, DialogHeader } from "components/dialog/DialogHeader"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import React, { useCallback, useContext, useEffect, useState } from "react"
import { initItemDialogData } from "./initData"
import { UserContext } from "contexts/UserContext"
import { pettyCashApiNm } from "./constant"
import { alertConfirmDelete, alertError } from "components/Alert"
import PayComponent from "./PayComponent"
import dayjs from "dayjs"
// import { useWhyDidYouUpdate } from "../../../hooks/useWhyDidYouUpdate"

const AddItemDialog = ({ maxAmount, pcTrnsId, prPCTrnsData, pcItmId, dialogOpen, setDialogOpen
  , onFinish, isFromJobOrder, updLnkSiteAbbr }) => {
  const { user } = useContext(UserContext)
  const { ax, msData } = useContext(GlobalStateContext)
  const [dialogData, setDialogData] = useState({ ...initItemDialogData })

  // Track which dependencies change
  // useWhyDidYouUpdate('AddItemDialog useEffect', {
  //   dialogOpen,
  //   ax,
  //   pcItmId,
  //   prPCTrnsData,
  //   maxAmount
  // });

  // Alternative: Manual tracking with useRef
  // const prevValues = useRef();

  // useEffect(() => {
  //   if (prevValues.current) {
  //     const changes = [];
  //     if (prevValues.current.dialogOpen !== dialogOpen) changes.push('dialogOpen');
  //     if (prevValues.current.ax !== ax) changes.push('ax');
  //     if (prevValues.current.pcItmId !== pcItmId) changes.push('pcItmId');
  //     if (prevValues.current.prPCTrnsData !== prPCTrnsData) changes.push('prPCTrnsData');
  //     if (prevValues.current.maxAmount !== maxAmount) changes.push('maxAmount');

  //     if (changes.length > 0) {
  //       console.log('Dependencies that changed:', changes);
  //     }
  //   }

  //   prevValues.current = { dialogOpen, ax, pcItmId, prPCTrnsData, maxAmount };
  // });

  // const initItemDialogDataMemo = useMemo(() => ({
  //   ...initItemDialogData,
  //   PayTm: dayjs().format("YYYY-MM-DD HH:mm"),
  //   PCJnlId: msData.pcJournalCombo.find(item => item.IsDf)?.id || null
  // })
  //   , [msData.pcJournalCombo])

  const handleDialogOK = useCallback(() => {
    if (!dialogData.PayTm || !dialogData.Amnt) {
      alertError("กรุณากรอกข้อมูลให้ครบถ้วน")
      return
    }
    if (!dayjs(dialogData.PayTm).isValid()) {
      alertError("รูปแบบเวลาทำรายการไม่ถูกต้อง")
      return
    }
    const postData = {
      ...dialogData,
      PCItmTm: dialogData.PayTm, //Coz PayComponent use PayTm for PCItmTm
      PCItmId: pcItmId,
      PCTrnsId: pcTrnsId,
      AdmAccId: user.AccId,
      InOutTypItm: dialogData.InOutTyp,
      getFn: "getPettyCashDetail",
      UpdLnkSiteAbbr: updLnkSiteAbbr,
    }
    if (isFromJobOrder) {
      const postData = {
        itemArgs: {
          ...dialogData,
          InOutTypItm: dialogData.InOutTyp,
          AdmAccId: user.AccId,
          PCItmTm: dialogData.PayTm,
        },
      }
      onFinish({ ...dialogData, ExpNm: msData.expObj[dialogData.ExpId]?.ExpNm, postData })
      setDialogOpen(false)
    } else {
      ax.post(pcItmId ? pettyCashApiNm.updatePCItem : pettyCashApiNm.insertPCItem, postData).then(value => {
        if (value.data) {
          onFinish(value.data)
          setDialogOpen(false)
        }
      })
    }
  }, [ax, dialogData, onFinish, setDialogOpen, user.AccId, pcTrnsId, pcItmId, isFromJobOrder
    , msData.expObj, updLnkSiteAbbr])

  const handleDeletePCItem = useCallback(() => {
    alertConfirmDelete(() => {
      ax.post(pettyCashApiNm.deletePCItem, { PCItmId: pcItmId, UpdLnkSiteAbbr: updLnkSiteAbbr, getArgs: { PCTrnsId: pcTrnsId } }).then(value => {
        if (value.data) {
          onFinish(value.data)
          setDialogOpen(false)
        }
      })
    })
  }, [ax, pcItmId, pcTrnsId, onFinish, setDialogOpen, updLnkSiteAbbr])
  useEffect(() => {
    // console.log('useEffect triggered with values:', {
    //   dialogOpen,
    //   pcItmId,
    //   prPCTrnsData,
    //   maxAmount
    // });

    if (dialogOpen) {
      console.log(pcItmId, prPCTrnsData, maxAmount)
      if (pcItmId) {
        ax.post(pettyCashApiNm.getPettyCashItem, { PCItmId: pcItmId, UpdLnkSiteAbbr: updLnkSiteAbbr }).then(value => {
          if (value.data && value.data.length === 1) {
            setDialogData({
              ...value.data[0],
              PayTm: value.data[0].PCItmTm, // use PayTm for PCItmTm coz PayComponent use PayTm
            })
          }
        })
      } else if (prPCTrnsData) {

        setDialogData({
          ...initItemDialogData,
          ...prPCTrnsData,
          isJobOrdIdCorrect: prPCTrnsData?.JobOrdId ? true : null,
          LocText: !prPCTrnsData?.JobOrdId ? "" : `${prPCTrnsData?.TakePlc || ""}-${prPCTrnsData?.Loc || ""}-${prPCTrnsData?.RtnPlc ?? ""}`,
          Amnt: maxAmount ?? "",
          PayTm: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        })
      } else {
        setDialogData({ ...initItemDialogData, PayTm: dayjs().format("YYYY-MM-DD HH:mm:ss") })
      }
    } else {
      setDialogData({ ...initItemDialogData })
    }
  }, [dialogOpen, ax, pcItmId, prPCTrnsData, maxAmount, updLnkSiteAbbr])


  return (
    <Dialog
      open={dialogOpen}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth='xs'
    >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title="รับใบเสร็จ-การใช้เงิน/รับเงิน"
        onDeleteClick={pcItmId ? handleDeletePCItem : null}
      />
      <DialogContent>
        <BoxFC pt={2} >
          <PayComponent
            updLnkSiteAbbr={updLnkSiteAbbr}
            dialogOpen={dialogOpen}
            dialogData={dialogData}
            setDialogData={setDialogData}
            isItemDialog={true} />
        </BoxFC>

      </DialogContent>
      <DialogFooter okText={"บันทึกข้อมูล"}
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={handleDialogOK} />
    </Dialog>
  )
}

export default React.memo(AddItemDialog)